import { useCurrentUserStorage, workspaceActions } from '@pn/core/storage';
import { apiAnnotationProvider } from '@pn/services/api/annotation/apiAnnotationProvider';
import React from 'react';

export function useAutoGetIntelWorkspaceItems() {
  const { isUserLoaded } = useCurrentUserStorage();
  const requestedRef = React.useRef(false);
  React.useEffect(() => {
    (async () => {
      if (!isUserLoaded || requestedRef.current) return;
      requestedRef.current = true;
      workspaceActions().updateIsFetching(true);

      const areaWorkspaceItems =
        await apiAnnotationProvider.getAnnotationAreaWorkspaceItems();

      workspaceActions().updateIsFetching(false);
      workspaceActions().add([...areaWorkspaceItems]);
    })();
  }, [isUserLoaded]);
}
